import React from 'react';
import { Heading } from '@edreamsodigeo/prisma-design-system';
import { useTranslation } from '@edreamsodigeo/frontend-core';

const ValuePropositionHeader = () => {
  const { t } = useTranslation();
  const textColor = 'neutral.90';

  return (
    <>
      <Heading fontSize={['type.5', '40px']} color={textColor}>
        {t('supportarea.mytripslogin.banner.title.1')}
      </Heading>
      <Heading fontSize={['type.5', '40px']} weight="medium" color={textColor}>
        {t('supportarea.mytripslogin.banner.title.2')}
      </Heading>
    </>
  );
};

export default ValuePropositionHeader;
